import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "select";
var classes = {
    ROOT: 'tyl-select',
    OPENED: 'tyl-select--opened',
    FOCUSED: 'tyl-select--focused',
    SELECT_DISABLED: 'tyl-select--disabled',
    SELECTED_TEXT: 'tyl-select__selected-text',
    MDC_NOTCHED_OUTLINE: 'mdc-notched-outline',
    LEADING_ICON: 'tyl-select--with-leading-icon',
    DROPDOWN: 'tyl-select__dropdown',
    NO_LABEL: 'tyl-select--no-label',
    DENSE: 'tyl-select--dense',
    ROOMY: 'tyl-select--roomy',
    INVALID: 'tyl-select--invalid',
    REQUIRED: 'tyl-select--required',
    LABEL_FLOAT: 'tyl-select--label-float',
    GROUP_WRAPPER: 'tyl-select__group-wrapper',
    INSET: 'tyl-select--inset',
    ADDON_END: 'tyl-select--addon-end',
    ADDON_END_CONTAINER: 'tyl-select__addon-end-container'
};
var selectors = {
    ROOT: "." + classes.ROOT,
    SELECTED_TEXT: "." + classes.SELECTED_TEXT,
    NOTCHED_OUTLINE: "." + classes.MDC_NOTCHED_OUTLINE,
    LABEL: 'label#select-label',
    LEADING_SLOT: 'slot[name=leading]',
    ADDON_END_SLOT: 'slot[name=addon-end]'
};
var attributes = {
    TYPE: 'type',
    VALUE: 'value',
    DENSITY: 'density',
    LABEL: 'label',
    MULTIPLE: 'multiple',
    DISABLED: 'disabled',
    INVALID: 'invalid',
    REQUIRED: 'required',
    FLOAT_LABEL_TYPE: 'float-label-type',
    PLACEHOLDER: 'placeholder',
    OBSERVE_SCROLL: 'observe-scroll',
    OBSERVE_SCROLL_THRESHOLD: 'observe-scroll-threshold',
    INSET: 'inset',
    DIALOG_WIDTH_THRESHOLD: 'dialog-width-threshold'
};
var events = {
    CHANGE: 'change',
    SCROLLED_BOTTOM: elementName + "-scrolled-bottom"
};
var numbers = {
    LABEL_SCALE: 0.75
};
export var SELECT_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    events: events,
    numbers: numbers
};
